import { registerComponent } from '@gig/magic-common';
import AccordionComponent from './accordion.vue.js';

var Accordion = registerComponent(AccordionComponent);

export { Accordion };
